import Vue from 'vue'
import Datepicker from 'vuejs-datepicker';
import {uk} from 'vuejs-datepicker/dist/locale'

Vue.component('test', Datepicker)



// WEBPACK FOOTER //
// ./plugins/datapicker.js